import styled from "styled-components";
import img_event_popup from "../image/img_event_popup2.jpg";
import ic_xmark from "../image/ic_xmark.png";
import { Content_Text } from "./theme";
import Cookie from "js-cookie";

const ModalBackground = styled.div`
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CloseButton = styled.button`
  align-self: flex-end;
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  padding: 10px;
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 500px;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;

  @media (max-width: 800px) {
    width: 350px;
  }
`;
const Button = styled.button`
  background-color: #3c2d84;
  width: 500px;
  height: 50px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  border-width: 0px;
  cursor: pointer;
  @media (max-width: 800px) {
    width: 350px;
  }
`;
function Modal({ show, onClose, go_Event_About }) {
  if (!show) {
    return null;
  }

  return (
    <ModalBackground>
      <ModalContainer>
        <CloseButton
          onClick={() => {
            onClose();
            Cookie.set("event_show", "no", {
              expires: new Date(new Date().getTime() + 1000 * 60 * 30),
            });
          }}
        >
          <img style={{ height: 20 }} src={ic_xmark} alt={ic_xmark} />
        </CloseButton>
        <Image src={img_event_popup} alt={img_event_popup} />
        <Button
          onClick={() => {
            go_Event_About();
            onClose();
            Cookie.set("event_show", "no", {
              expires: new Date(new Date().getTime() + 1000 * 60 * 30),
            }); // 유효 기간 7일로 설정
          }}
        >
          <Content_Text $white $bold>
            이벤트 참여하기
          </Content_Text>
        </Button>
      </ModalContainer>
    </ModalBackground>
  );
}
export default Modal;
